import React, { useEffect, useState } from "react";
// import RoomBookingTable from "./Components/RoomBookingTable";
// import { useDispatch} from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RestaurantSubCategoryTable from "./SubCategoryComponts/RestaurantSubCateogoryTable";
import AddRestaurantSubCategory from "./SubCategoryComponts/AddRestaurantSubCategory";
import { hasAddAccess } from "../../../../Common/CheckAccess";

const RestaurantSubCategoryList = () => {
  // const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const paramData = useParams();
  const [selectedCategory, setSelectedCategory] = useState();

  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);
  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Dish Items List</h3>
              <div className="col-auto d-flex w-sm-100 align-content-center gap-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ maxHeight: "40px" }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Back
                </button>
                {hasAddAccess(permissions, "restaurant") && (
                  <button
                    type="button"
                    className="btn btn-dark"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#add-sub-category"
                    aria-controls="add-sub-category"
                    onClick={() => setSelectedCategory(null)}
                  >
                    Add Dish Item
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <RestaurantSubCategoryTable
                  categoryId={paramData?.categoryId}
                  setSelectedCategory={setSelectedCategory}
                  // data ={roomReservation.data}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddRestaurantSubCategory
        categoryId={paramData?.categoryId}
        setSelectedCategory={setSelectedCategory}
        selectedCategory={selectedCategory}
      />
    </>
  );
};
export default RestaurantSubCategoryList;
